/**
 * K线图均线装饰器
 */
import {
  LINE_TYPE,
  KLINE_MATYPE,
} from '../../../viewmodel/setting.js';
import Util, {mergeModelData, curryFun} from '../../../util/index.js';
const model = {
  maData: {
    Type: Object,
    Default: () => ({})
  }
};
const KLineMADectorator = BaseClass => class extends BaseClass {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcRange() {
    super._calcRange();
    const {maData} = this.state.data;
    const {
      KLINE_MA5,
      KLINE_MA10,
      KLINE_MA20,
      KLINE_MA30,
      KLINE_MA60,
      KLINE_MA120
    } = KLINE_MATYPE;
    const {[KLINE_MA5]: ma5 = [], [KLINE_MA10]: ma10 = [], [KLINE_MA20]: ma20 = [],[KLINE_MA30]: ma30 = [], [KLINE_MA60]: ma60 = [],[KLINE_MA120]: ma120 = []} = maData;
    this.calcRange({data: [ma5, ma10, ma20, ma30, ma60, ma120], targetKey: 'close_px', isAdditional: true});
  }
  _calcAxis() {
    super._calcAxis();
    const {maData} = this.state.data;
    const {
      KLINE_MA5,
      KLINE_MA10,
      KLINE_MA20,
      KLINE_MA30,
      KLINE_MA60,
      KLINE_MA120
    } = KLINE_MATYPE;
    const {[KLINE_MA5]: ma5, [KLINE_MA10]: ma10, [KLINE_MA20]: ma20, [KLINE_MA30]: ma30, [KLINE_MA60]: ma60, [KLINE_MA120]: ma120} = maData;
    const curryCalcAxis = curryFun(this.calcAxis, this, {
      targetKey: 'close_px',
      sourceKey: 'lineY',
      isAdditional: true,
    });
    curryCalcAxis({data: ma5});
    curryCalcAxis({data: ma10});
    curryCalcAxis({data: ma20});
    curryCalcAxis({data: ma30});
    curryCalcAxis({data: ma60});
    curryCalcAxis({data: ma120});
  }
  _drawMain() {
    super._drawMain();
    const {
      left,
      width,
      bottom,
    } = this.availArea;
    const {maData} = this.state.data;
    const {
      KLINE_MA5,
      KLINE_MA10,
      KLINE_MA20,
      KLINE_MA30,
      KLINE_MA60,
      KLINE_MA120
    } = KLINE_MATYPE;
    const {[KLINE_MA5]: MA5 = [], [KLINE_MA10]: MA10 = [], [KLINE_MA20]: MA20 = [],[KLINE_MA30]: MA30 = [], [KLINE_MA60]: MA60 = [], [KLINE_MA120]: MA120 = []} = maData;
    const {LINE} = LINE_TYPE;
    const {ma5, ma10, ma20, ma30, ma60, ma120} = this.option.MA;
    this._drawLine(LINE, MA5, left, bottom, ma5.lineWidth, ma5.color);
    this._drawLine(LINE, MA10, left, bottom, ma10.lineWidth, ma10.color);
    this._drawLine(LINE, MA20, left, bottom, ma20.lineWidth, ma20.color);
    this._drawLine(LINE, MA30, left, bottom, ma30.lineWidth, ma30.color);
    this._drawLine(LINE, MA60, left, bottom, ma60.lineWidth, ma60.color);
    this._drawLine(LINE, MA120, left, bottom, ma120.lineWidth, ma120.color);
  }
}
export default KLineMADectorator;
